import React from 'react';

export default function ConfidenceBadge({ value, showBar = false, showLabel = true }) {
  // Normalize — could be 0-1 or 0-100
  const pct = value <= 1 ? Math.round(value * 100) : Math.round(value);
  const isHigh = pct >= 85;
  const isMed = pct >= 65;
  const color = isHigh ? 'var(--color-success)' : isMed ? 'var(--color-warning)' : 'var(--color-error)';
  const bg = isHigh ? '#ECFDF5' : isMed ? '#FFFBEB' : '#FEF2F2';
  const icon = isHigh ? '✓' : isMed ? '●' : '⚑';
  const label = isHigh ? 'High' : isMed ? 'Medium' : 'Low';

  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 4 }}>
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        padding: '2px 8px', borderRadius: 'var(--radius-full)',
        fontSize: '0.75rem', fontWeight: 600,
        color, background: bg,
      }}>
        {icon} {pct}%{showLabel && ` · ${label}`}
      </span>
      {showBar && (
        <div style={{ width: '100%', height: 3, background: 'var(--color-border)', borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 2, transition: 'width 0.3s' }} />
        </div>
      )}
    </div>
  );
}